// Déclenche le téléchargement d'un Blob dans le navigateur via un <a> synthétique.
// Pattern identique CampaignDashboard (à déduper tech-debt, hors scope Story 2.4).
export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
